export const COMPANY_NAME_ALREADY_EXISTS =
    'Redirect: One company is already exists for this company name.';
